module.exports = __webpack_public_path__ + "static/media/devfest_img_01.23b2cb38.jpg";